const PageIntro = ({
  title,
  subtitle,
  compactBottom = false,
  bottomPadding,
  children,
  contentWidthClass = "max-w-4xl",
}) => {
  const resolvedPadding = bottomPadding
    ? bottomPadding
    : compactBottom
    ? "pb-8 md:pb-10"
    : "pb-16 md:pb-20";
  const resolvedTopPadding = compactBottom
    ? "pt-20 md:pt-24"
    : "pt-24 md:pt-32";

  return (
    <section
      className={`bg-ofWhite text-[#1a1c23] ${resolvedTopPadding} ${resolvedPadding}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="space-y-2">
          <h1 className="text-3xl md:text-[56px] font-semibold tracking-tight inline-block relative">
            {title}
            <span className="absolute bottom-0 left-1 border-box mt-3 h-[2px]"></span>
          </h1>

          {subtitle && (
            <p className="text-base md:text-lg text-[#1c3d72]/90">{subtitle}</p>
          )}
        </div>
      </div>
      {children ? (
        <div
          className={`${contentWidthClass} mx-auto px-4 sm:px-6 lg:px-8 ${
            compactBottom ? "mt-8 pt-4 border-t border-[#1c3d72]/10" : "mt-10"
          }`}
        >
          {children}
        </div>
      ) : (
        compactBottom && (
          <div
            className={`${contentWidthClass} mx-auto px-4 sm:px-6 lg:px-8 mt-8`}
          >
            <div className="h-px w-full bg-[#1c3d72]/10" aria-hidden="true" />
          </div>
        )
      )}
    </section>
  );
};

export default PageIntro;
